import React, {useEffect, useRef} from 'react';
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../core/gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../../../core/gd-components/buttons/control-button/@types";
import Input from "../../../../../core/gd-form-elements/input/input";
import {MenuSpaceSearch} from "../../search/menu-space-search";

type Props = {
    className?      : string
    spaceSearch     : MenuSpaceSearch
}

export default function MenuTopHeader_SearchButton(props: Props) {

    const spaceSearch = props.spaceSearch


    const onClick = ()=>{
        spaceSearch.isActive = true
        spaceSearch.reRender()
    }

    if (!gd.ui.hasMenuSearch) return null

    return (
        <ControlButtonStandard className    = {props.className}
                               type         = {ControlButtonType.SEARCH}
                               size         = {ControlButtonSize.SIZE_28}
                               onClick      = {onClick}/>
    )
}
